import { makeStateKey, StateKey, TransferState } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable, of } from 'rxjs';

/**
 * Chave da TransferState com as traduções de um idioma.
 *
 * Existe por causa da hidratação: o `TranslatePipe` devolve `''` até o JSON do
 * idioma chegar, e no cliente ele chega por HTTP, DEPOIS do primeiro render. Com
 * o HTML vindo pronto do servidor, isso faria todo texto fixo da tela (“Aberto
 * agora”, “Buscar”, “Entrega”) sumir no instante da hidratação e voltar em
 * seguida. O servidor grava aqui as traduções que usou; o cliente as lê de forma
 * síncrona e o primeiro render sai igual ao do servidor.
 */
export function chaveDasTraducoes(idioma: string): StateKey<Record<string, any>> {
    return makeStateKey<Record<string, any>>(`i18n:${idioma}`);
}

/**
 * Loader do navegador: usa as traduções que o servidor embutiu no HTML e só vai
 * à rede quando elas não existem — que é o caso de todo boot sem SSR (a
 * TransferState vem vazia) e de quem usa um idioma diferente do que o servidor
 * renderizou. Em qualquer desses casos o comportamento é o de antes.
 */
export class TranslateLoaderComEstadoDoServidor implements TranslateLoader {
    private readonly rede: TranslateHttpLoader;

    constructor(http: HttpClient, private readonly estado: TransferState) {
        this.rede = new TranslateHttpLoader(http, './assets/i18n/', '.json');
    }

    getTranslation(idioma: string): Observable<any> {
        const chave = chaveDasTraducoes(idioma);
        if (this.estado.hasKey(chave)) {
            const traducoes = this.estado.get(chave, null);
            this.estado.remove(chave);
            if (traducoes) return of(traducoes);
        }
        return this.rede.getTranslation(idioma);
    }
}
